// @flow
import React from "react";
import KeyFob from "../../../svg/facilities/has_keyfob.svg";

import "./keyFobIcon.scss";

const KeyFobIcon = () => <KeyFob className="c-key-fob-icon" />;

export default KeyFobIcon;
